import React, { Component } from "react";

import Ripples from "react-ripples";
// import history from "../historyone";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import AppBar from "./AppBar";
import { Map, Circle, GoogleApiWrapper } from "google-maps-react";
import Geocode from "react-geocode";
import firebase from "firebase/app";
import firestore from "firebase/firestore";
import { firebaseConfig } from "./FirebaseConfig";
import { BsCircleFill } from "react-icons/bs";



export class Maps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map_center: {
        //latlng for view map
        lat: 24.916624,
        lng: 67.074067,
      },
      Zones: [],
      zoom: 11,
      place: {},
      zones_latitude: null, //for create zones
      zones_longitude: null, //for create zones
      radius: null, //for create zones
      zones_type: null,
    };
  }

  componentDidMount() {
    this.getCordinates();
    // setInterval(() => {
    //     this.getCordinates();
    //     // console.warn("kdbcjkbckajs")
    // }, 1000
  
    // )
    this.onChangeKey();
  }
  
  onChangeKey(uid, startTime, endTime, days) {
    var today = new Date();
   
    var d = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // var d = new Date(dateString);
    var dayName = d[today.getDay()];

    let Current_day = dayName
    // let cd = Current_day.toLocaleString('de-AT',{weekday:'long'})
    console.log("current day = ",dayName)

    // let Current_hour = today.getHours()
    // let Current_mins = today.getMinutes()
console.log(days)
    let time = today.toLocaleString('de-AT', { hour: 'numeric', minute:'numeric', hour24: true })

    let num;
    if (days == undefined) {
      
    }
    else{
    num = days.length
    for (let index = 0; index < num; index++) {
      console.log("current day", Current_day)
      console.log("Index", days[index])
      // const element = array[index];
      if (days[index] == Current_day) {
        
        console.log("DANCE")
        if (time == startTime) {
          console.log("Time is equal to start Time")
          this.updateKeyToOne(uid, 1);
          // alert("key updated to 1")

        }else if(time == endTime){
          console.log("Time is not equal to start Time")
          this.updateKeyToZero(uid, 0);
          // alert("key updated to 0")
        }
        
      } else {
        console.log("NO DANCE")

      }
    }
    }
    // console.log("Days length: ", num)
    

    // if (startTime == currentTime) {
    //   // alert("key updated to 1")
    //   this.updateKeyToOne(uid, 1);
    // } else if (endTime == currentTime) {
    //   this.updateKeyToZero(uid, 0);
    //   // alert("key updated to 0")
    // }
  }
  
  
  updateKeyToOne = async (uid, key) => {
    const db = firebase.firestore();
    const res = await db.collection('zones').doc(uid).update({
        key: key
    });
  }
  
  updateKeyToZero = async (uid, key) => {
    const db = firebase.firestore();
    const res = await db.collection('zones').doc(uid).update({
        key: key,
        startTime: null,
        endTime: null
    });
  }

  createCircle(uid, lat, long, rad, zones_type, startTime, endTime, key, days) {
    //create circles/Zones
    this.onChangeKey(uid, startTime, endTime, days)

    if (zones_type == "Critical") {
      if (key == 1) {
        return (
          <Circle
            radius={rad}
            center={{ lat: lat, lng: long }}
            onMouseover={() => console.log("mouseover")}
            onClick={() => console.log("click")}
            onMouseout={() => console.log("mouseout")}
            strokeColor="transparent"
            strokeOpacity={0}
            strokeWeight={5}
            fillColor="#ECFF03" //yellow colour
            fillOpacity={0.5}
          />
        );
      } else if (key == 0) {
        return (
          <Circle
            radius={rad}
            center={{ lat: lat, lng: long }}
            onMouseover={() => console.log("mouseover")}
            onClick={() => console.log("click")}
            onMouseout={() => console.log("mouseout")}
            strokeColor="transparent"
            strokeOpacity={0}
            strokeWeight={5}
            fillColor="#FF0000" //red colour
            fillOpacity={0.5}
          />
        );
      }
    } else if (zones_type == "Mild") {
      if (key == 1) {
        return (
          <Circle
            radius={rad}
            center={{ lat: lat, lng: long }}
            onMouseover={() => console.log("mouseover")}
            onClick={() => console.log("click")}
            onMouseout={() => console.log("mouseout")}
            strokeColor="transparent"
            strokeOpacity={0}
            strokeWeight={5}
            fillColor="#ECFF03" //yellow colour
            fillOpacity={0.5}
          />
        );
      } else if (key == 0) {
        return (
          <Circle
            radius={rad}
            center={{ lat: lat, lng: long }}
            onMouseover={() => console.log("mouseover")}
            onClick={() => console.log("click")}
            onMouseout={() => console.log("mouseout")}
            strokeColor="transparent"
            strokeOpacity={0}
            strokeWeight={5}
            fillColor="#0096FF" //blue colour
            fillOpacity={0.5}
          />
        );
      }
    }
  }

  getCordinates = async () => { //get zones data from firebase
    let tempdata = []
    const db = firebase.firestore();
    const snapshot = await db.collection('zones').get();
    snapshot.forEach((doc) => {
        let tempobj = {
            'uid': doc.id, 'latitude': doc.data().latitude, 'zones_type': doc.data().zones_type, 'longitude': doc.data().longitude,
            'place': doc.data().place, 'radius': doc.data().radius, 'startTime': doc.data().startTime, 'endTime': doc.data().endTime,
            'key': doc.data().key,
        };
        tempdata.push(tempobj)
    });
    this.setState({ Zones: tempdata })
    
}

 

  render() {
    // console.log("Values = ", this.state.zones);

    return (
      <div
        style={{
          width: "100%",
          height: "505.4px",
          position: "absolute",
          boxShadow: "5px 5px 3px 3px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Map
          initialCenter={this.state.map_center}
          google={this.props.google}
          // style={{ width: 500, height: 500, position: 'relative' }}
          zoom={this.state.zoom}
          //onReady={this.createCircle()}
        >
          <div
            style={{
              backgroundColor: "lightgrey",
              height: "20vh",
              width: "20%",
              position: "relative",
              // float: "right",
              top: "10vh",
              marginLeft: "1.5vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              opacity: '0.8',
              border:'0.4vh solid darkgrey',
              boxShadow: '0 8px 6px -6px black'
            }}
          >
            <div
              style={{ 
                // backgroundColor: "red", 
                height: "6.5vh", 
                width: "100%", 
                display:'flex',
                flexDirection:'row',
                justifyContent:'flex-start',
                alignItems:'center',
                padding:'1vh'
              }}
            >
              <BsCircleFill 
                style={{ height: 27, width: 27, color: "#FF0000", marginRight:'2vh' }}
              />
              <p style={{color:'black', fontWeight:'bold',marginTop:'2vh'}}>Critical Zones</p>
            </div>
            <div
              style={{ 
                // backgroundColor: "red", 
                height: "6.5vh", 
                width: "100%", 
                display:'flex',
                flexDirection:'row',
                justifyContent:'flex-start',
                alignItems:'center',
                padding:'1vh'
              }}
            >
              <BsCircleFill 
                style={{ height: 27, width: 27, color: "#0096FF", marginRight:'2vh' }}
              />
              <p style={{color:'black', fontWeight:'bold',marginTop:'2vh'}}>Mild Zones</p>
            </div>
            <div
              style={{ 
                // backgroundColor: "red", 
                height: "6.5vh", 
                width: "100%", 
                display:'flex',
                flexDirection:'row',
                justifyContent:'flex-start',
                alignItems:'center',
                padding:'1vh'
              }}
            >
              <BsCircleFill 
                style={{ height: 27, width: 27, color: "#ECFF03", marginRight:'2vh' }}
              />
              <p style={{color:'black', fontWeight:'bold',marginTop:'2vh'}}>Relaxing Zones</p>  
            </div>
           
          </div>

          {this.state.Zones.map((value) =>
            // console.log("check value lat = "+value.latitude),
            // console.log("check value hour = "+value.hour),
            // this.createCircle(value.latitude, value.longitude, value.radius, value.zones_type,
            //     value.startTime, value.endTime, value.key
            //     )
            this.createCircle(
              value.uid,
              value.latitude,
              value.longitude,
              value.radius,
              value.zones_type,
              value.startTime,
              value.endTime,
              value.key,
              value.days
            )
          )}
        </Map>
      </div>
    );
  }
}

// export default Dashboard
export default GoogleApiWrapper({
  apiKey: "AIzaSyA_d3pS7JqjFnGWc9hHkvT2MUQvAKo5Bio",
  // apiKey: "AIzaSyAtXimJkT6rGxmA_WglAzBuDQLTqmrikVs", //working

})(Maps);
